module.exports = {
          srcSet: __webpack_public_path__ + "7cfe9f7870fcffe27726c8390e988f5a-886.png"+" 886w",
          images:[ {path: __webpack_public_path__ + "7cfe9f7870fcffe27726c8390e988f5a-886.png",width: 886,height: 390}],
          src: __webpack_public_path__ + "7cfe9f7870fcffe27726c8390e988f5a-886.png",
          toString:function(){return __webpack_public_path__ + "7cfe9f7870fcffe27726c8390e988f5a-886.png"},
          
          width: 886,
          height: 390
        }